/*export const dateFormat = (date) => {
  return new Date(date).toLocaleDateString("en-US");
};*/

export const dateFormat = (date) => {
  if (!date) return '';
  
  // If date is in yyyy-MM-dd format (from backend), parse it directly without timezone conversion
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split('-');
    return new Date(year, month - 1, day).toLocaleDateString("en-US");
  }
  
  // Otherwise use normal date parsing
  return new Date(date).toLocaleDateString("en-US");
};


